import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

import { AccountService } from 'src/app/accounts/accountService';
import { CasesService } from 'src/app/cases-v2/services/cases.service';
import { OpportunityService } from 'src/app/opportunities/opportunity.service';
import { AppMainService } from '../../../../app-main.service';
import { ContactService } from '../../../../contacts/contactService';
import { LeadService } from '../../../../leads/leadService';
import { GlobalSearchPath } from '../../constants/global-search-path';
import { ObjectNames } from "../../constants/object.names";
import { ConfirmationService, MessageService } from 'primeng/api';
import { LeadHelper } from 'src/app/leads-v2/services/lead.helper';
import { AccountHelper } from 'src/app/accounts-v2/services/accounts.helper';

@Component({
    selector: "app-shared-detail-popup",
    templateUrl: "./shared-detail-popup.component.html",
    styleUrls: ["./shared-detail-popup.component.scss"],
})

export class SharedDetailPopupComponent implements OnInit {
    @Input() moduleType: string;
    @Input() currentDisplay: boolean;
    @Input() header: String;
    @Input() dataId: any;
    @Input() associationTypeId: number;
    @Input() column = [];
    @Output() dialogClosed = new EventEmitter<any>();
    @Output() closeModal = new EventEmitter();
    data: any;
    isShow = false;
    paths = GlobalSearchPath;
    objectNames = ObjectNames;
    leadAccountStatus;
    displayEditViewDialog: boolean = false ;

    constructor(
        private router: Router,
        private appMainService: AppMainService,
        private accountService: AccountService,
        private contactService: ContactService,
        private leadService: LeadService,
        private opportunityService: OpportunityService,
        private caseService: CasesService,
        private messageService: MessageService,
        private leadHelper: LeadHelper,
        private accountHelper: AccountHelper) { }

    ngOnInit(): void {
        if (this.dataId && this.dataId > 0) {
            this.getDetails(this.dataId);
            this.isShow = this.setIsShowIcon();
        } else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Details Id not found...' });
        }
        if(this.moduleType == this.objectNames.ACCOUNT){this.displayEditViewDialog = true}
    }

    getDetails(id) {
        if (id) {
            if (this.moduleType === this.objectNames.CONTACT) {
                this.getContactDetails(id);
            } else if (this.moduleType === this.objectNames.LEADS) {
                this.getLeadDetails(id);
            } else if (this.moduleType === this.objectNames.ACCOUNT) {
                this.getAccountDetails(id);
            } else if (this.moduleType === this.objectNames.OPPORTUNITY) {
                this.getOpportunityDetails(id);
            } else if (this.moduleType === this.objectNames.CASES) {
                this.getCaseDetails(id);
            }
        }
    }

    setIsShowIcon() {
        const url = this.router.url.replace('/', '').split('?')[0];

        if ((url === this.paths.Lead && this.moduleType !== this.objectNames.LEADS) ||
            (url === this.paths.Contact && this.moduleType !== this.objectNames.CONTACT) ||
            (url === this.paths.Account && this.moduleType !== this.objectNames.ACCOUNT) ||
            (url === this.paths.Case && this.moduleType !== this.objectNames.CASES) ||
            (url === this.paths.Opportunity && this.moduleType !== this.objectNames.OPPORTUNITY) ||
            url == this.paths.SavedSearch) {
            return true;
        }

        return false;
    }

    getContactDetails(id) {
        this.appMainService.isShowSpinner('getContactDetails');

        this.contactService.getContactById(id,this.associationTypeId)
            .then(res => {
                this.appMainService.isHideSpinner('getContactDetails');
                this.data = res;

                if (!this.data) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Details Data not found...' });
                    return;
                }

                if (this.data) {
                    this.data['email'] = '';
                    this.data['phone'] = '';
                    let EmailHome = '';
                    let EmailPersonal = '';
                    let EmailWork = '';
                    let EmailOther = '';
                    let Email = '';
                    if (this.data.contactEmails) {
                        for (let e of this.data.contactEmails) {
                            if (e.email) {
                                if (e.email.emailType.name == "Work Email")
                                    EmailWork = e.email.emailAddress;
                                if (e.email.emailType.name == "Personal")
                                    EmailPersonal = e.email.emailAddress;
                                if (e.email.emailType.name == "Home")
                                    EmailHome = e.email.emailAddress;
                                if (e.email.emailType.name == "Other")
                                    EmailOther = e.email.emailAddress;
                            }
                        }

                        if (EmailWork != "") { Email = EmailWork }
                        else if (EmailPersonal != "") { Email = EmailPersonal }
                        else if (EmailHome != "") { Email = EmailHome }
                        else if (EmailOther != "") { Email = EmailOther }
                    }
                    let PhoneWork = { number: '', code: '', extension: '' };
                    let PhoneMobile = { number: '', code: '', extension: '' };
                    let PhoneHome = { number: '', code: '', extension: '' };
                    let PhoneFax = { number: '', code: '', extension: '' };
                    let PhoneOther = { number: '', code: '', extension: '' };
                    let PhoneMain = { number: '', code: '', extension: '' };
                    let PhoneInActive = { number: '', code: '', extension: '' };
                    let PhoneCP1 = { number: '', code: '', extension: '' };
                    let PhoneCP2 = { number: '', code: '', extension: '' };
                    let Phone = { number: '', code: '', extension: '' };
                    if (this.data.contactPhones) {
                        for (let p of this.data.contactPhones) {
                            const { number, phoneType, code, extension = '' } = p.phone;
                            if (p.phone) {
                                switch (phoneType?.name) {
                                    case "Mobile Phone":
                                      PhoneMobile = { number, code, extension };
                                      break;
                                    case "Home Phone":
                                      PhoneHome = { number, code, extension };
                                      break;
                                    case "Work Phone":
                                      PhoneWork = { number, code, extension };
                                      break;
                                    case "Fax":
                                      PhoneFax = { number, code, extension };
                                      break;
                                    case "Other":
                                      PhoneOther = { number, code, extension };
                                      break;
                                    case "Main":
                                      PhoneMain = { number, code, extension };
                                      break;
                                    case "InActive":
                                      PhoneInActive = { number, code, extension };
                                      break;
                                    case "CP1":
                                      PhoneCP1 = { number, code, extension };
                                      break;
                                    case "CP2":
                                      PhoneCP2 = { number, code, extension };
                                      break;
                                  }
                            }
                        }
                        if (PhoneMobile.number) { Phone = PhoneMobile }
                        else if (PhoneHome.number) { Phone = PhoneHome }
                        else if (PhoneWork.number) { Phone = PhoneWork }
                        else if (PhoneFax.number) { Phone = PhoneFax }
                        else if (PhoneOther.number) { Phone = PhoneOther }
                        else if (PhoneMain.number) { Phone = PhoneMain }
                        else if (PhoneInActive.number) { Phone = PhoneInActive }
                        else if (PhoneCP1.number) { Phone = PhoneCP1 }
                        else if (PhoneCP2.number) { Phone = PhoneCP2 }
                    }
                    this.data['email'] = Email;
                    this.data['phone'] = Phone;
                }
            })
            .catch(() => {
                this.appMainService.isHideSpinner('getContactDetails');
            });
    }

    closeAccountViewEditModal() {
        this.displayEditViewDialog = false
        this.closeModal.emit();
        this.dialogClosed.emit();
      }

    getLeadDetails(id) {

        this.appMainService.isShowSpinner('getLeadDetails');

        this.leadService.getLeadById(id)
            .then(res => {
                this.appMainService.isHideSpinner('getLeadDetails');
                this.data = res;
                // this.data  = this.leadHelper.processLeadDetailsData(res);
                if (!this.data) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Details Data not found...' });
                    return;
                }


                this.leadAccountStatus = this.data.statusId === 1;
                this.isShow = this.leadAccountStatus && this.setIsShowIcon();
            })
            .catch(() => {
                this.appMainService.isHideSpinner('getLeadDetails');
            });
    }

    getAccountDetails(id) {
        this.appMainService.isShowSpinner('getAccountDetails');
        this.accountService.getAccountDetails(id)
            .then(res => {
                this.appMainService.isHideSpinner('getAccountDetails');
                this.data = res;
                // this.data = this.accountHelper.processAccountDetailsData(res);
                this.leadAccountStatus = this.data.statusId === 1;
                if (!this.data) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Details Data not found...' });
                    return;
                }
            })
            .catch(() => {
                this.appMainService.isHideSpinner('getAccountDetails');
            });
    }

    getOpportunityDetails(id) {
        this.appMainService.isShowSpinner('getAccountDetails');

        this.opportunityService.getOpportunityByIdDetails(id)
            .toPromise()
            .then(res => {
                this.appMainService.isHideSpinner('getAccountDetails');
                this.data = res;

                if (!this.data) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Details Data not found...' });
                    return;
                }
            })
            .catch(() => {
                this.appMainService.isHideSpinner('getAccountDetails');
            });
    }

    getCaseDetails(id) {
        this.appMainService.isShowSpinner('getCaseDetails');

        this.caseService.getCasesById(id)
            .toPromise()
            .then(res => {
                this.appMainService.isHideSpinner('getCaseDetails');
                this.data = res;

                if (!this.data) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Details Data not found...' });
                    return;
                }
            })
            .catch(() => {
                this.appMainService.isHideSpinner('getCaseDetails');
            });
    }

    getLabelName(dynamicNameParam, staticName) {
        let column = this.column?.find(x => x.field == dynamicNameParam);
        return column && column.labelname ? column.labelname : staticName;
    }

    setDataDetails() {
        let url = '';

        if (this.moduleType === this.objectNames.CONTACT) {
            url = this.paths.Contact;
        } else if (this.moduleType === this.objectNames.LEADS) {
            url = this.paths.Lead;
        } else if (this.moduleType === this.objectNames.ACCOUNT) {
            url = this.paths.Account;
            // url = this.paths.Account2;
        } else if (this.moduleType === this.objectNames.OPPORTUNITY) {
            url = this.paths.Opportunity;
        } else if (this.moduleType === this.objectNames.CASES) {
            url = this.paths.Case;
        }

        if (!this.data) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Details Data not found...' });
            return;
        }

        const queryParams = {
            id: this.data.id,
            module: this.moduleType,
            statusId: this.data.statusId,
            globalSearch: true,
            data: this.data.businessName,
        };

        if (this.moduleType === this.objectNames.LEADS || this.moduleType === this.objectNames.ACCOUNT) {
            queryParams['channelId'] = this.data.typeId;
            queryParams['data'] = this.data.businessName;
        } else if (this.moduleType === this.objectNames.CONTACT) {
            queryParams['data'] = [this.data.firstName, this.data.middleName, this.data.lastName].join(' ');
            queryParams['assocTypeId'] = this.associationTypeId;
        } else if (this.moduleType === this.objectNames.OPPORTUNITY) {
            queryParams['channelId'] = this.data.pipelineId;
            queryParams['data'] = this.data.name;
        } else if (this.moduleType === this.objectNames.CASES) {
            queryParams['data'] = this.data.associationName;
        }
        const currentUrl = this.router.url.replace('/', '').split('?')[0];

        //saved-search redirect to new url
        if (currentUrl == this.paths.SavedSearch) {
            url = this.router.serializeUrl(this.router.createUrlTree([`/${url}`], { queryParams: { ...queryParams } }));
            window.open(url, '_blank');
        }
        else {
            this.router
                .navigateByUrl("/", { skipLocationChange: true })
                .then(() =>
                    this.router.navigate([url], {
                        queryParams
                    })
                );
        }
    }

    hideDialog() {
        this.dialogClosed.emit();
    }

}

